import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import { openMultiUpdateClientModal } from 'App/components/MultiActionModal/MultiUpdateClient/openMultiUpdateClientModal';
import AppService from 'App/legacy/AppService';

export default function updateCompany(
	rb: RequestBuilder,
	entity: string,
	extraParams?: object,
	multiSelect?: MultiSelect
) {
	const opts = {
		customerId: AppService.getCustomerId(),
		filters: rb,
		extraParams,
		entity,
		multiSelect
	};

	return openMultiUpdateClientModal(opts);
}
